import { CalibrationModel } from '../types/calibration-model.enum';

export const getCalibrationType = (model: CalibrationModel) =>
  model === CalibrationModel.EFFECTIVE_ENERGY_GT2_SIMPLE ? 'simple' : 'multi';
